import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { IEmployee } from '../../model/employee'
import { EmployeeService } from '../../services/employee.service';
import { SlotsService } from '../../services/slots.services';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms'
import { AnalyticsService } from '../../services/analytics.service';
import { AmazingTimePickerService } from 'amazing-time-picker'; // this line you needi
// import * as moment from 'moment-timezone';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-employee-slots',
  templateUrl: './employee-slots.component.html',
  styleUrls: ['./employee-slots.component.scss']
})
export class EmployeeSlotsComponent implements OnInit {
  public reports: { response: any }
  selectedDoctor: IEmployee;
  slotList: { response: any };
  isAddRecord: boolean = true;
  public formSubmitAttempt: boolean = false;
  public isSlide: boolean = false;
  endTimeValidaton: boolean = false;
  slotForm: FormGroup;
  localtimeZone : any;

  statusMessage: string = "Loading data please wait...";
  daysList = [
    { value: 'Monday' },
    { value: 'Tuseday' },
    { value: 'Wedensday' },
    { value: 'Thursday' },
    { value: 'Friday' },
    { value: 'Saturday' },
    { value: 'Sunday' }
  ]
  constructor(private _analyticsService: AnalyticsService, private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder, private atp: AmazingTimePickerService, private _slotsService: SlotsService) {
    this.slotForm = fb.group({
      associatedday: ['', Validators.compose([Validators.required])],
      starttime: ['', [Validators.required]],
      endtime: ['', Validators.compose([Validators.required])],
      minutes: ['', [Validators.required]],
  
    }, {
      Validators: this.endTimeValidator // your validation method
    })

    var zone_name =  moment.tz.guess();
    var timezone = moment.tz(zone_name).zoneAbbr() 
    console.log('zone_name ', zone_name);
    this.localtimeZone = zone_name;
  }


  private endTimeValidator(AC: AbstractControl) {
    if (AC.get('endtime').value > AC.get('starttime').value) {
      this.endTimeValidaton = true;

    }
    else {
      this.endTimeValidaton = false;
      AC.get('endtime').setErrors({ endTimeValidaton: true })
      this.slotForm.controls['endtime'].setErrors({ 'incorrect': true });
      this.isAddRecord = true;
    }
    return { isGreater: AC.get('endtime').value > AC.get('starttime').value }
  }

  open() {
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe(time => {
      console.log(time);
    });
  }

  ngOnInit() {

    const $ = window["$"];
    function toggleIcon(e) {
      $(e.target)
        .prev('.panel-heading')
        .find(".more-less")
        .toggleClass('glyphicon-plus glyphicon-minus');
    }
    $('.panel-group').on('hidden.bs.collapse', toggleIcon);
    $('.panel-group').on('shown.bs.collapse', toggleIcon);

    this.slotForm.controls.associatedday.setValue("Monday");

    this.selectedDoctor = this._employeeService.getEmpleeData();
    if (this.selectedDoctor == undefined || this.selectedDoctor.id == undefined || !this.selectedDoctor.id) {

      this.router.navigate(['employeeList']);
    }
    else {
      this._slotsService.getSlots(this.selectedDoctor.id)
        .subscribe(
          (employeeData) => {
            if (employeeData == null) {
              this.statusMessage = "Employee Id does not exist..";
            }
            else {
              this.slotList = employeeData;
              console.log('this.slotList 1' , this.slotList);
              for(let index = 0; index < this.slotList.response.appointmentSlots.length; index++){
                for(let innerIndex = 0; innerIndex < this.slotList.response.appointmentSlots[index].slots.length ; innerIndex++){
                  // if(!this.slotList.response.appointmentSlots[index].slots[innerIndex].zonevalue){
                    this.slotList.response.appointmentSlots[index].slots[innerIndex].startTime = this.formatTimeForSlots(this.slotList.response.appointmentSlots[index].slots[innerIndex].startTime); 
                    this.slotList.response.appointmentSlots[index].slots[innerIndex].endTime = this.formatTimeForSlots(this.slotList.response.appointmentSlots[index].slots[innerIndex].endTime); 
                  // }
                }
              }
            }
            console.log('this.slotList' , this.slotList);
          },
          (error) => {
            this.statusMessage = "Problem with the service. Please try again after sometime";
            console.log(error);
          }

        );
    }
    this.getAppointments(this.selectedDoctor.id)
  }



  // time format.
  parseDaytime(time) {
    let [hours, minutes] = time.substr(0, time.length  -3).split(":").map(Number);
    if (time.includes("PM") && hours !== 12) hours += 12;
    return 1000/*ms*/ * 60/*s*/ * (hours * 60 + minutes);
  }

  formatTime(providedDate){
    let hours = providedDate.substring(0, 2);
    let minutes = providedDate.substring(3,5);
    if(providedDate.includes("PM") && hours !== 12){
      hours = parseInt(hours) + 12;
    }
    let finalDate = new Date(); 
    finalDate.setHours(hours);
    finalDate.setMinutes(minutes);
	  let formatedDate = finalDate.toLocaleString();
    let slotDate;
    slotDate = new Date(formatedDate);
	  let zone_name =  moment.tz.guess();
	  zone_name = ""+zone_name+"";
	  slotDate = slotDate.toLocaleString("en-US", {timeZone: zone_name})
    let currentDate = new Date(slotDate);
    currentDate.setSeconds(0);
    let currentHour =  currentDate.getHours();
    let currentMinutes :any =  currentDate.getMinutes();
    let currentAMPM = '';

    currentAMPM = currentHour >= 12 ? 'PM' : 'AM';
    currentHour = currentHour % 12; 
    currentHour = currentHour ? currentHour : 12; 
    currentMinutes = currentMinutes < 10 ? '0' + currentMinutes : currentMinutes;
    // console.log('currentHour ', currentHour);
    // if(currentHour > 12){
    //   currentHour = currentHour-12;
    //   currentAMPM = 'PM';
    // }
    // else if(currentHour < 13){
    //   currentAMPM = 'AM';
    // }
    // else{
    //   currentAMPM = 'AM';
    // }
    let dataObject = {
      'Hours': currentHour,
      'Minutes': currentMinutes,
      'AMPM': currentAMPM
    }
    let mindate = currentMinutes.toString();
    let hourdate = currentHour.toString();
    if(mindate.length == 1 ){
      mindate = '0'+mindate;
    }
    if(hourdate.length == 1){
      hourdate = '0'+hourdate;
    }
    let finalResult = hourdate+':'+mindate+' '+currentAMPM;
    return finalResult;

  }


  formatTimeForSlots(providedDate){
    console.log('providedDate ', providedDate);
      let hours = providedDate.substring(0, 2);
    let minutes = providedDate.substring(3,5);
    if(providedDate.includes("PM") && hours !== 12){
      hours = parseInt(hours) + 12;
    }
    let finalDate = new Date(); 
    finalDate.setHours(hours);
    finalDate.setMinutes(minutes);
	  let formatedDate = finalDate.toLocaleString();
    let slotDate;
    slotDate = new Date(formatedDate);
	  let zone_name =  moment.tz.guess();
	  zone_name = ""+zone_name+"";
	  slotDate = slotDate.toLocaleString("en-US", {timeZone: zone_name})
    let currentDate = new Date(slotDate);
    currentDate.setSeconds(0);
    let currentHour =  currentDate.getHours();
    let currentMinutes :any =  currentDate.getMinutes();
    let currentAMPM = '';
    
    currentAMPM = currentHour >= 12 ? 'PM' : 'AM';
    currentHour = currentHour % 12; 
    currentHour = currentHour ? currentHour : 12; 
    currentMinutes = currentMinutes < 10 ? '0' + currentMinutes : currentMinutes;
    // console.log('currentHour ', currentHour);
    // if(currentHour > 12){
    //   currentHour = currentHour-12;
    //   currentAMPM = 'PM';
    // }
    // else if(currentHour < 13){
    //   currentAMPM = 'AM';
    // }
    // else{
    //   currentAMPM = 'AM';
    // }
    let dataObject = {
      'Hours': currentHour,
      'Minutes': currentMinutes,
      'AMPM': currentAMPM
    }
    let mindate = currentMinutes.toString();
    let hourdate = currentHour.toString();
    if(mindate.length == 1 ){
      mindate = '0'+mindate;
    }
    if(hourdate.length == 1){
      hourdate = '0'+hourdate;
    }
    let finalResult = hourdate+':'+mindate+' '+currentAMPM;
    console.log('finalResult ', finalResult)
    return finalResult;

  }

  getAppointments(selectDoctor) {
    this.formatTimeForSlots('03:30 PM');
    this._analyticsService.getFutureAppointments()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.reports = employeeData.response.appointmentList.filter((element) => {
              if (element.doctorId == selectDoctor) {
                return element;
              }
            });
          }

          console.log(this.reports);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }
  addRecord() {
    if (this.isAddRecord == false) {
      this.isAddRecord = true;
    }
    else {
      this.isAddRecord = false;
    }


  }

  // formatStartTime(dateFormat: any) {
  //   console.log('formatStartTime ', dateFormat);
  //   let hours = dateFormat.substring(0, 2);
  //   let hoursInt = parseInt(hours);
  //   let ampmStatus = dateFormat.includes("PM");
  //   let minute = dateFormat.substring(3, 5);
  //   let ampm = '';
  //   // if(ampmStatus){
  //   //   ampm = 'PM';
  //   // }
  //   // else{
  //   //   ampm = 'AM';
  //   // }
  //   if (hoursInt > 12) {
  //     ampm = 'PM';
  //     let minutes = dateFormat.substring(3, 5);
  //     if (hoursInt !== 12) {
  //       hoursInt = hoursInt - 12;
  //     }
  //   }
  //   else{
  //     ampm = 'AM';
  //   }
  //   let finalResult = hoursInt+':'+minute;
  //   console.log('finalResult 123', finalResult)
  //   return finalResult;
    
  // }

  // getParsedHour(data){
  //   let userTime = data;
  //   let userHour = data.substring
  // }


  SaveSlots(data) {
    this.formSubmitAttempt = true;
    if (this.isAddRecord == false) {
      this.isAddRecord = true;
    }
    else {
      this.isAddRecord = false;
    }
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    this.slotForm.value.token = loginUser.token;
    this.slotForm.value.employeeid = this.selectedDoctor.id;
    this.slotForm.value.interval = this.slotForm.value.minutes;
    this.slotForm.value.utcstarttime = '';
    this.slotForm.value.utcendtime = '';
    console.log('this.slotForm.value.starttime ', this.slotForm.value.starttime);
    console.log('this.slotForm.value.endtime ', this.slotForm.value.endtime);
    if (this.slotForm.valid) {
      if (this.slotForm.value.endtime > this.slotForm.value.starttime) {
        // console.log('this.slotForm.value.starttime 1', this.slotForm.value.starttime);
        // console.log('this.slotForm.value.endtime 2', this.slotForm.value.endtime);
        // this.slotForm.value.starttime = this.formatTimeForSlots(this.slotForm.value.starttime);
        // this.slotForm.value.endtime = this.formatTimeForSlots(this.slotForm.value.endtime);
        // console.log('this.slotForm.value.starttime 3', this.slotForm.value.starttime);
        // console.log('this.slotForm.value.endtime 4', this.slotForm.value.endtime);
        this._slotsService.saveSlots(this.slotForm.value, this.localtimeZone).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("Slots created Sucessfully");
              this.selectedDoctor = this._employeeService.getEmpleeData();
              this._slotsService.getSlots(this.selectedDoctor.id)
                .subscribe(
                  (employeeData) => {
                    if (employeeData == null) {
                      this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                      this.slotList = employeeData;
                      for(let index = 0; index < this.slotList.response.appointmentSlots.length; index++){
                        for(let innerIndex = 0; innerIndex < this.slotList.response.appointmentSlots[index].slots.length ; innerIndex++){
                          // if(!this.slotList.response.appointmentSlots[index].slots[innerIndex].zonevalue){
                            this.slotList.response.appointmentSlots[index].slots[innerIndex].startTime = this.formatTimeForSlots(this.slotList.response.appointmentSlots[index].slots[innerIndex].startTime); 
                            this.slotList.response.appointmentSlots[index].slots[innerIndex].endTime = this.formatTimeForSlots(this.slotList.response.appointmentSlots[index].slots[innerIndex].endTime); 
                          // }
                        }
                      }
                      this.formSubmitAttempt = false;
                      this.slotForm.reset();
                      this.slotForm.controls.associatedday.setValue("Monday");
                    }
                    console.log(this.slotList);
                  },
                  (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                  }

                );
            }

            else {
              alert(data.returnMsg)

            }
          },
          error => {
            alert(error)
            console.log(error)
          });

      }
      else {
        alert("Endtime must be greater than start time")
        this.isAddRecord = true;
        return;
      }

    }
    else {
      this.isAddRecord = true;
      return;
    }

  }

  toggleIcon(e) {
    $(e.target)
      .prev('.panel-heading')
      .find(".more-less")
      .toggleClass('glyphicon-plus glyphicon-minus');
  }

  hasError(obj) {
    console.log(obj)
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }
  changeSlot(e, id) { // here e is a native event
    let status = '';
    if (e.target.checked) {
      status = 'true';
    } else {
      status = 'false';
    }
    this._slotsService.changeSlot(id, status).subscribe((data) => {
      if (data.returnCode == 0) {
        alert("Slots updated Sucessfully");
      }
    }, (err) => {
      alert(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/employee-slots/employee-slots.component.ts